export interface SearchableWorkflow {
  displayName: string
  description?: string | null
}

export function matchesWorkflowSearch(workflow: SearchableWorkflow, search: string): boolean {
  const query = search.toLowerCase()
  return workflow.displayName.toLowerCase().includes(query) || (workflow.description ?? '').toLowerCase().includes(query)
}
